import { ItemAllocationMethod } from '../../capital-account/ItemAllocationMethod';
import { FinancialStatementItemDTO } from '../common/FinancialStatementItemDTO';
import { AllocationMethod } from '../../../utils/capital-account/utils';


export class ItemAllocationMethodDTO {
  public uuid: string;
  public itemDTO: FinancialStatementItemDTO;
  public method: AllocationMethod;

  constructor(uuid: string, itemDTO: FinancialStatementItemDTO, allocationMethod: AllocationMethod) {
    this.uuid = uuid;
    this.itemDTO = itemDTO;
    this.method = allocationMethod;
  }

  static toItemAllocationMethod(dto: ItemAllocationMethodDTO): ItemAllocationMethod {
    return new ItemAllocationMethod(dto.uuid, FinancialStatementItemDTO.toEntity(dto.itemDTO), dto.method);
  }

  static toItemAllocationMethodList(itemAllocationMethodDTOs: ItemAllocationMethodDTO[]): ItemAllocationMethod[] {
    return itemAllocationMethodDTOs.map(
      (itemAllocationMethodDTO) => ItemAllocationMethodDTO.toItemAllocationMethod(itemAllocationMethodDTO),
    );
  }
}
